import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";

import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";

import { TimezoneSelectComponent } from "./timezone-select.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
  ],
  exports: [TimezoneSelectComponent],
  declarations: [TimezoneSelectComponent],
})
export class TimezoneSelectModule {}
